import React, { createContext, FC, useContext, useState } from 'react';
import { Trans } from 'react-i18next';
import { Bankrupt } from 'src/front/api/apiInstance';
import { SearchBankruptInterfaceType } from 'src/front/api/generated';
import styled from 'styled-components';

interface BankruptState {
  searchBankrupt: (interfaceType: SearchBankruptInterfaceType) => Promise<any>;
}

const BankruptStateContext = createContext<BankruptState>({
  searchBankrupt: (interfaceType: SearchBankruptInterfaceType) => {
    // empty
  },
} as BankruptState);

const CustomLabel = styled.p`
  padding-left: 20px;

  color: red;

  font-size: 14px;
  font-weight: bold;
`;

const BankruptProvider: FC = ({ children }) => {
  const [isBankrupt, setBankrupt] = useState(false);
  const searchBankrupt = async (interfaceType: SearchBankruptInterfaceType): Promise<any> => {
    const { data } = await Bankrupt.searchBankrupt({ interfaceType });
    if (data.result === 'OK') {
      if (data.isBankrupt) {
        setBankrupt(true);
      } else {
        setBankrupt(false);
      }
    }
  };

  return (
    <BankruptStateContext.Provider value={{ searchBankrupt }}>
      {isBankrupt ? (
        <CustomLabel>
          <Trans i18nKey="bankruptInfo_label" />
        </CustomLabel>
      ) : null}
      {children}
    </BankruptStateContext.Provider>
  );
};

const useSearchBankrupt = (): BankruptState => {
  return useContext(BankruptStateContext);
};

export { BankruptProvider, useSearchBankrupt };
